import type { FaireProductEntity } from "../../entity_types/product";

export const p_fxy95zwsbx: FaireProductEntity = {
  token: "p_fxy95zwsbx",
  type: "product",
  name: "GARDEN LANE - Chic Floral Rain Boots - ✈️SHIPS FAST",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/f7148f371eb84575fca339bf4f322c98d80de5df7bec26b14504f40e7d5c10a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96397832c33260ecd355d1bd0a8c3ed1b2b04d73f9c303e9984def15f902ac03.jpeg",
    "https://cdn.faire.com/fastly/85d0388fcb7fef05efd41ea8246cf69bd1b4f8ec67af7e564bda105d4b20bd47.jpeg",
    "https://cdn.faire.com/fastly/5cbece4d353a8d4fe2ddb48c59a4b7c5a2f63c1afd89cbfc4f53766acd857677.jpeg",
    "https://cdn.faire.com/fastly/d5d8ee07176b80669f616b73c1fce2f105282b5bc734ffacd717ff39f70b7de0.jpeg",
    "https://cdn.faire.com/fastly/c0ccef1638a9c0f7a3bb5f55cee62d20be2fb77ab5f3acdb530f59a4434e41e8.jpeg",
    "https://cdn.faire.com/fastly/e2ee16f0567c7af1fcad96c089252eea9f7754a0278bb5a7d77f2193e63d9383.jpeg",
    "https://cdn.faire.com/fastly/f28731eca9da9195330d9ab912bd2c95d11434107fd42d2e729ec3fc463cc634.jpeg",
    "https://cdn.faire.com/fastly/41795d7fc2b9e80ed9eee780d2a6cb7f2335c38952b6b5d39a33ebebeac03b36.jpeg",
  ],
  priceDollars: 28.75,
  description:
    "Ready to ship today!\n\nStep into rainy days with a touch of charm. Our Garden Lane Rain Boots combine functionality with a fresh, feminine flair, perfect for brightening even the grayest skies. Designed with a durable, waterproof finish and sturdy tread soles, these boots keep you dry and comfortable through puddles and downpours. The delicate floral print adds a whimsical, cottagecore-inspired look that pairs effortlessly with everything from casual jeans to flowy dresses.\nAvailable in white floral, blue floral, lavender floral, and pink floral.\n\nOOTD: Style them with light-wash denim tucked into the boots, a cozy oversized knit sweater, and a trench coat for a chic yet practical rainy-day look. Add a pastel umbrella to tie in the floral tones. 🌸",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:10.314Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
